export default __webpack_public_path__ + "static/media/token_right_mobile.e7fad6f8.png";